import * as yup from 'yup';

export const branchSchema = yup.object({
  name: yup.string().required('Branch name is required').min(2, 'Name must be at least 2 characters'),
  code: yup.string().required('Branch code is required').min(2, 'Code must be at least 2 characters'),
  country_code: yup.string().required('Country code is required').min(2, 'Country code must be at least 2 characters'),
  is_active: yup.boolean().required('Active status is required'),
});
